// extracted by mini-css-extract-plugin
export default {"grid":"StrategyPage_grid__lb2WZ","section":"StrategyPage_section__9AAIm","indicators":"StrategyPage_indicators__DpPUv","strategy":"StrategyPage_strategy__qHGzl"};